import $http from '../../shared/http';

export const zones = {
  namespaced: true,
  state: () => {
    return {
      zonesForSelect: null,
      zoneData: null,
      zoneFormData: null,
      isZoneEdited: false,
      editedZoneID: null,
      isZoneCreated: null,
      createdZoneID: null,
      existingZoneNames: null,
    };
  },
  getters: {
    getZonesForSelect: (state) => {
      return state.zonesForSelect && state.zonesForSelect.length
        ? state.zonesForSelect.sort((a, b) => a.text.toUpperCase() - b.text.toUpperCase())
        : null;
    },
    getCurrentZone: (state) => state.zoneData,
    getCurrentZoneID: (state) => (state.zoneData ? state.zoneData.id : null),
    getZoneEditData: (state) => state.zoneData,
    getZoneEditFormData: (state) => state.zoneFormData,
    getZoneRegisterFormData: (state) => state.zoneFormData,
    getExistingZoneNames: (state) => state.existingZoneNames,
  },
  mutations: {
    setZonesForSelect: (state, payload) => (state.zonesForSelect = payload),
    setZoneData: (state, data) => {
      state.zoneData = data;
    },
    clearResponseData: (state) => {
      state.zoneCreated = null;
      state.isZoneEdited = null;
      state.newZoneID = null;
      state.editedZoneID = null;
    },
    setZoneEditData(state, form) {
      state.zoneFormData = form;
    },
    setZoneRegisterData(state, form) {
      state.zoneFormData = form;
    },
    setExistingZoneNames: (state, data) => {
      state.existingZoneNames = data;
    },
  },
  actions: {
    async LOAD_ZONES_FOR_SELECT({ commit, rootGetters }, { churchId }) {
      const isLoggedInForSelfRegistration =
        rootGetters['membership_self_registrations/isLoggedInForSelfRegistration'];
      const selfRegistrationToken =
        rootGetters['membership_self_registrations/getSelfRegistrationToken'];

      if (!churchId && !isLoggedInForSelfRegistration) {
        throw new Error('Church ID not provided');
      }
      return $http('v2')
        .get(
          isLoggedInForSelfRegistration
            ? 'membership_self_registrations/zones/select?token=' + selfRegistrationToken
            : `organisations/${churchId}/zones/select`,
          { canBeImpersonated: true }
        )
        .then((response) => {
          commit('setZonesForSelect', response.data.data);
          return response;
        });
    },

    async loadZoneData({ commit }, { organisation_id, id }) {
      return await $http('v2')
        .get(`organisations/${organisation_id}/zones/${id}`)
        .then(async (response) => {
          commit('setZoneData', response.data.data);
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    async createZoneAction({ commit }, form) {
      commit('clearResponseData');
      return new Promise(async (resolve, reject) => {
        await $http()
          .post(`/zones`, form, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            return resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async editZoneAction(ctx, { id, form }) {
      return $http()
        .patch(`/zones/${id}`, form, {
          headers: { 'X-Is-Notifiable': 'On' },
        })
        .then(async (response) => {
          return response.data.data;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async deleteZone(ctx, { id }) {
      return $http()
        .delete(`/zones/${id}`, { notifiable: true })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    async getZoneNamesAction({ commit }, { churchId }) {
      return new Promise(async (resolve, reject) => {
        commit('setExistingZoneNames', null);
        await $http()
          .get(`/organisations/${churchId}/zones/check/names`, { canBeImpersonated: true })
          .then((response) => {
            commit('setExistingZoneNames', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
